import { ACCREDITATION_GRID_SORT_DISABLED, ACCREDITATION_GRID_SORT_ENABLED } from '../actions/accreditation_grid_sort'

export function accreditationGridSort(state = { sortField: null }, action) {
  switch (action.type) {
    case ACCREDITATION_GRID_SORT_ENABLED:
      return { ...state, sortField: action.sortField }
    case ACCREDITATION_GRID_SORT_DISABLED:
      return { ...state, sortField: null }
    default:
      return state
  }
}
